import React from 'react';
import moment from 'moment';
import TimeAgo from 'react-time-ago'
import DashIcon from 'react-icons/lib/md/linear-scale';

const IataFailedRecord = ({report}) => {

    return (
        <div className="timeline-box-w failed">
            <div className="timeline-time">
            <span>
                <TimeAgo>{ parseInt(moment(report.EntryDateTime).format('x'), 0)}</TimeAgo>
            </span>
            </div>
            <div className="timeline-box">
                { report.SearchStartDate  &&
                <div className="timeline-info">
                    <h6 className="timeline-role">
                        {report.AirlineName}
                    </h6>

                    <h6>
                        { moment((report.SearchStartDate).split('T')[0]).format('MMM Do, YYYY')}
                        &nbsp;&nbsp;
                        <DashIcon size="22" color="#212121"/>
                        &nbsp;&nbsp;
                        { moment((report.SearchEndDate).split('T')[0]).format('MMM Do, YYYY')}
                    </h6>
                    <p className="timeline-title m-0">
                        Report {report.Status}
                    </p>
                    <div>
                    </div>
                </div>
                }
                { !report.SearchStartDate  &&
                <div className="timeline-info">
                    <h5 className="timeline-role">
                        {report.AirlineName}
                    </h5>
                    <p className="timeline-title m-0">
                        Report {report.Status}
                    </p>
                    <div>
                    </div>
                </div>
                }

            </div>
        </div>
    );
};

export default IataFailedRecord;


// WEBPACK FOOTER //
// ./src/views/iata/iata-failed-record.js